<template>
    <svg viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.45673 5.70392C1.75826 4.97597 2.20022 4.31453 2.75738 3.75738C3.31453 3.20022 3.97596 2.75826 4.70392 2.45673C5.43188 2.1552 6.2121 2 7.00003 2C7.78796 2 8.56818 2.1552 9.29614 2.45673C10.0241 2.75826 10.6855 3.20022 11.2427 3.75738L13 5.51471L14.7573 3.75738C15.8826 2.63216 17.4087 2.00002 19 2.00002C20.5913 2.00002 22.1174 2.63216 23.2426 3.75738C24.3679 4.8826 25 6.40873 25 8.00003C25 9.59133 24.3679 11.1175 23.2426 12.2427L13 22.4853L2.75738 12.2427C2.20022 11.6855 1.75826 11.0241 1.45673 10.2961C1.1552 9.56818 1 8.78797 1 8.00003C1 7.2121 1.1552 6.43188 1.45673 5.70392Z"
            fill="url(#paint0_linear_20962_353222)"
        />
        <path
            d="M1.45673 5.70392C1.75826 4.97597 2.20022 4.31453 2.75738 3.75738C3.31453 3.20022 3.97596 2.75826 4.70392 2.45673C5.43188 2.1552 6.2121 2 7.00003 2C7.78796 2 8.56818 2.1552 9.29614 2.45673C10.0241 2.75826 10.6855 3.20022 11.2427 3.75738L13 5.51471L14.7573 3.75738C15.8826 2.63216 17.4087 2.00002 19 2.00002C20.5913 2.00002 22.1174 2.63216 23.2426 3.75738C24.3679 4.8826 25 6.40873 25 8.00003C25 9.59133 24.3679 11.1175 23.2426 12.2427L13 22.4853L2.75738 12.2427C2.20022 11.6855 1.75826 11.0241 1.45673 10.2961C1.1552 9.56818 1 8.78797 1 8.00003C1 7.2121 1.1552 6.43188 1.45673 5.70392Z"
            fill="url(#paint1_linear_20962_353222)"
            fill-opacity="0.2"
        />
        <path
            d="M1.45673 5.70392C1.75826 4.97597 2.20022 4.31453 2.75738 3.75738C3.31453 3.20022 3.97596 2.75826 4.70392 2.45673C5.43188 2.1552 6.2121 2 7.00003 2C7.78796 2 8.56818 2.1552 9.29614 2.45673C10.0241 2.75826 10.6855 3.20022 11.2427 3.75738L13 5.51471L14.7573 3.75738C15.8826 2.63216 17.4087 2.00002 19 2.00002C20.5913 2.00002 22.1174 2.63216 23.2426 3.75738C24.3679 4.8826 25 6.40873 25 8.00003C25 9.59133 24.3679 11.1175 23.2426 12.2427L13 22.4853L2.75738 12.2427C2.20022 11.6855 1.75826 11.0241 1.45673 10.2961C1.1552 9.56818 1 8.78797 1 8.00003C1 7.2121 1.1552 6.43188 1.45673 5.70392Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.8525 12.1084C13.2074 11.9521 13.4808 11.7764 13.6729 11.5811C13.8682 11.3825 14 11.1709 14.0684 10.9463C14.1367 10.7184 14.1709 10.4596 14.1709 10.1699C14.1709 9.56445 14.0602 9.11523 13.8389 8.82227C13.6208 8.52604 13.3213 8.37793 12.9404 8.37793C12.7516 8.37793 12.5791 8.40072 12.4229 8.44629C12.2699 8.48861 12.1527 8.55371 12.0713 8.6416C12.4456 8.75228 12.6328 8.99479 12.6328 9.36914C12.6328 9.57747 12.5579 9.75 12.4082 9.88672C12.2617 10.0234 12.0729 10.0918 11.8418 10.0918C11.7018 10.0918 11.5781 10.0609 11.4707 9.99902C11.3633 9.93392 11.2786 9.84928 11.2168 9.74512C11.1582 9.6377 11.1289 9.52214 11.1289 9.39844C11.1289 9.20964 11.1794 9.04688 11.2803 8.91016C11.3812 8.77018 11.5212 8.64323 11.7002 8.5293C12.0973 8.29492 12.597 8.17773 13.1992 8.17773C13.6745 8.17773 14.0928 8.25098 14.4541 8.39746C14.8187 8.54069 15.1003 8.74902 15.2988 9.02246C15.5007 9.29264 15.6016 9.61165 15.6016 9.97949C15.6016 10.5264 15.3737 10.9886 14.918 11.3662C14.4622 11.7438 13.8405 12.0221 13.0527 12.2012V13.6611H12.8525V12.1084ZM12.96 14.5986C13.2236 14.5986 13.432 14.6686 13.585 14.8086C13.738 14.9453 13.8145 15.1325 13.8145 15.3701C13.8145 15.6077 13.738 15.7965 13.585 15.9365C13.432 16.0732 13.2236 16.1416 12.96 16.1416C12.6995 16.1416 12.4928 16.0732 12.3398 15.9365C12.1868 15.7965 12.1104 15.6077 12.1104 15.3701C12.1104 15.1325 12.1868 14.9453 12.3398 14.8086C12.4928 14.6686 12.6995 14.5986 12.96 14.5986Z"
            fill="#FDFEFF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_20962_353222"
                x1="1"
                y1="2"
                x2="26.0296"
                y2="3.34651"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#96CA00" />
                <stop offset="0.447917" stop-color="#96CA00" />
                <stop offset="1" stop-color="#A5D034" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_20962_353222"
                x1="10.7143"
                y1="22.4853"
                x2="10.7143"
                y2="1.71548"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-opacity="0.5" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "HeartQuestionOutlineIcon",
    props: {
        borderColor: {
            type: String,
            default: "currentColor",
        },
    },
};
</script>
